import {Component} from "@angular/core"

@Component({
    selector: "tf-disclaimer-component",
    templateUrl: "./disclaimer.component.html",
    styleUrls: ["./disclaimer.component.scss"]
})
export class DisclaimerComponent {
}
